var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HorseTable',{attrs:{"id":"HorseSailies","headers":_vm.headers,"title":"Historique des saillies","table-items":_vm.filteredSessionsByType}})}
var staticRenderFns = []

export { render, staticRenderFns }